import { Search } from "lucide-react"

import { Label } from "@/components/ui/label"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarInput,
} from "@/components/ui/sidebar"
import { Input } from "../ui/input";
import { cn } from "@/lib/utils";
import React from "react";

export function SearchForm({ onSubmit, ...props }: React.ComponentProps<"form">) {
  const [q, setQ] = React.useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit?.(e);
  };

  return (
    <form onSubmit={handleSubmit} {...props}>
      <SidebarGroup className="py-0 bg-transparent dark:bg-transparent">
        <SidebarGroupContent className="relative">
          <Label htmlFor="search" className="sr-only">Search</Label>
          <Input
            id="search"
            data-sidebar="input"
            className={cn("pl-8 h-8 w-full bg-background dark:bg-zinc-800 shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring")}
            placeholder={props.title as string}
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <Search className="pointer-events-none absolute left-2 top-1/2 size-4 -translate-y-1/2 select-none opacity-50" />
        </SidebarGroupContent>
      </SidebarGroup>
    </form>
  );
}

